<template>
    <div @click="handleClick" class="foodmash-card foodmash-default">
        <div class="foodmash-frame">
            <span>{{ defaultMessage }}</span>
        </div>
    </div>
</template>

<script>
import cardMixin from "../cardMixin";

export default {
    name: 'FoodmashDefaultCard',
    mixins: [cardMixin],
    props: {
        swiped: Boolean,
        defaultMessage: String,
    },
    data() {
        return {
            panning: false,
            shouldRun: true
        }
    },
    methods: {
        handleClick() {
            if (!this.panning && this.shouldRun) {
                this.swipe('swiperight');
            }

            this.shouldRun = true
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/FoodmashDefaultCard.vue